module.exports = __webpack_public_path__ + "static/media/phone-blue.547104dd.svg";